// resolves a data table header value, which may be a plain key ("schoolName")
// or a path into a nested object ("client.fullName")
const valueAtPath = (item, path) => {
  return String(path)
    .split(".")
    .reduce((value, key) => value?.[key], item);
};

// keeps the first record of each distinct combination of the given fields, so
// records that render identically collapse into one row
export const deduplicate = (records, fields) => {
  const seen = new Set();
  return records.filter((record) => {
    const key = fields.map((field) => valueAtPath(record, field)).join("|");
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
